const PEX_DATAPOINT_EXCEED_ERROR = [
    'gpuNum',
    'info',
    'link',
    'actual',
    'expected'
]

export {
    PEX_DATAPOINT_EXCEED_ERROR
}